// extracted by mini-css-extract-plugin
export default {"smsCode":"SmsCodeInput_smsCode__qSItX","smsCodeInput":"SmsCodeInput_smsCodeInput__f2jG2","errorInput":"SmsCodeInput_errorInput__rWRR-"};